import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import AgentWorkspace from './pages/AgentWorkspace';
import ProjectManagement from './pages/ProjectManagement';
import ProjectDetail from './pages/ProjectDetail';
import DocumentReview from './pages/DocumentReview';
import IndustryData from './pages/IndustryData';
import EngineeringCases from './pages/EngineeringCases';
import TechnicalStandards from './pages/TechnicalStandards';
import IndustryDocuments from './pages/IndustryDocuments';
import PolicyLaws from './pages/PolicyLaws';
import WaterConservationWebsites from './pages/WaterConservationWebsites';
import ExpertDatabase from './pages/ExpertDatabase';
import Profile from './pages/Profile';
import ErosionCalculator from './pages/ErosionCalculator';
import DamCalculator from './pages/DamCalculator';
import BenefitCalculator from './pages/BenefitCalculator';
import TopsoilCalculator from './pages/TopsoilCalculator';
import Skills from './pages/Skills';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/MainLayout';
import './App.css';

function App() {
  return (
    <AntdApp>
      <Routes>
        <Route path="/" element={<MainLayout><Home /></MainLayout>} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/agent" element={
          <ProtectedRoute>
            <MainLayout><AgentWorkspace /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/agent/:agentType" element={
          <ProtectedRoute>
            <MainLayout><AgentWorkspace /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/projects" element={
          <ProtectedRoute>
            <MainLayout><ProjectManagement /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/projects/:id" element={
          <ProtectedRoute>
            <MainLayout><ProjectDetail /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/documents/:documentId/review" element={
          <ProtectedRoute>
            <MainLayout><DocumentReview /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/industry" element={
          <ProtectedRoute>
            <MainLayout><IndustryData /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/industry/cases" element={
          <ProtectedRoute>
            <MainLayout><EngineeringCases /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/industry/standards" element={
          <ProtectedRoute>
            <MainLayout><TechnicalStandards /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/industry/documents" element={
          <ProtectedRoute>
            <MainLayout><IndustryDocuments /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/industry/policies" element={
          <ProtectedRoute>
            <MainLayout><PolicyLaws /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/industry/websites" element={
          <ProtectedRoute>
            <MainLayout><WaterConservationWebsites /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/experts" element={
          <ProtectedRoute>
            <MainLayout><ExpertDatabase /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/calculator/erosion" element={<MainLayout><ErosionCalculator /></MainLayout>} />
        <Route path="/calculator/dam" element={<MainLayout><DamCalculator /></MainLayout>} />
        <Route path="/calculator/benefit" element={<MainLayout><BenefitCalculator /></MainLayout>} />
        <Route path="/calculator/topsoil" element={<MainLayout><TopsoilCalculator /></MainLayout>} />
        <Route path="/skills" element={
          <ProtectedRoute>
            <MainLayout><Skills /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <MainLayout><Profile /></MainLayout>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AntdApp>
  );
}

export default App;
